import { useEffect, useState } from 'react'
import { CollapsibleSection } from './CollapsibleSection'
import { roundToDecimal } from '../common/utils'
import { UnitCategoryId } from '../common/enums'
import { useAccountContext } from '../contexts'

interface Props {
  device: any
}

export function DeviceSiteDetails({ device }: Props) {
  const { userUnitSettings } = useAccountContext()
  const [data, setData] = useState<string[][]>([])
  const [title, setTitle] = useState('Site Name: ')

  useEffect(() => {
    if (device && userUnitSettings !== undefined) {
      setTitle(`Site Name: ${device.siteName}`)

      const elevation = calculateElevation(device.coordinateZValue)

      setData([
        [
          `Site Code: ${device.siteCode || ''}`,
          `Latitude: ${roundToDecimal(device.coordinateNSValue, 10)}`,
          `Longitude: ${roundToDecimal(device.coordinateEWValue, 10)}`,
          `Elevation: ${elevation}`,
        ],
      ])
    }

    function calculateElevation(elevationInMeters: number) {
      if (userUnitSettings[UnitCategoryId.DepthHeightDistance].unitId === 65) {
        return `${roundToDecimal(elevationInMeters, 2)} m`
      }
      return `${roundToDecimal(elevationInMeters / 0.3048, 2)} ft`
    }
  }, [device, userUnitSettings])

  return (
    <CollapsibleSection title={title} open={false}>
      <table className={tailwind.table}>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} className={index % 2 === 0 ? tailwind.even : tailwind.odd}>
              {row.map((item, index) => (
                <td key={index}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </CollapsibleSection>
  )
}

const tailwind = {
  table: 'table-fixed w-full',
  even: 'text-black text-l font-regular h-10 py-2.5 pl-4 pr-4 w-full border-b bg-[#f9f9f9]',
  odd: 'text-black text-l font-regular h-10 py-2.5 pl-4 pr-4 w-full border-b bg-[#fff]',
  // even: 'flex flex-auto justify-between text-black text-l font-regular py-2.5 pl-4 pr-4 w-full border-b bg-[#f9f9f9]',
  // odd: 'flex flex-auto justify-between text-black text-l font-regular py-2.5 pl-4 pr-4 w-full border-b bg-[#fff]',
}
